import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "inlineSearch", "input", "panel", "results", "context"]
  static values = { url: String }

  connect() {
    this._onKeydown = this._handleGlobalKeydown.bind(this)
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
  }

  toggle(event) {
    event.stopPropagation()
    if (this.buttonTarget.classList.contains("hidden")) {
      this.close()
    } else {
      this._open()
    }
  }

  close() {
    this.buttonTarget.classList.remove("hidden")
    this.buttonTarget.classList.add("flex")
    this.inlineSearchTarget.classList.add("hidden")
    this.inlineSearchTarget.classList.remove("flex")
    this.panelTarget.classList.add("hidden")
    this.inputTarget.value = ""
    this.resultsTarget.removeAttribute("src")
    this.resultsTarget.replaceChildren()
    this.contextTargets.forEach(context => context.classList.remove("hidden"))
  }

  search() {
    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => {
      const q = this.inputTarget.value.trim()
      if (q.length < 2) {
        this.panelTarget.classList.add("hidden")
        this.resultsTarget.removeAttribute("src")
        this.resultsTarget.replaceChildren()
        return
      }
      this.panelTarget.classList.remove("hidden")
      this.resultsTarget.src = `${this.urlValue}?q=${encodeURIComponent(q)}`
    }, 300)
  }

  clickOutside(event) {
    if (this.buttonTarget.classList.contains("hidden") === false) return
    if (this.inlineSearchTarget.contains(event.target)) return
    if (this.panelTarget.contains(event.target)) return
    if (event.target.closest("[data-action*='erp--search#toggle']")) return
    this.close()
  }

  _open() {
    this.contextTargets.forEach(context => context.classList.add("hidden"))
    this.buttonTarget.classList.add("hidden")
    this.buttonTarget.classList.remove("flex")
    this.inlineSearchTarget.classList.remove("hidden")
    this.inlineSearchTarget.classList.add("flex")
    this.inputTarget.focus()
  }

  _handleGlobalKeydown(event) {
    if (event.key === "Escape" && this.buttonTarget.classList.contains("hidden")) {
      this.close()
      return
    }

    if ((event.metaKey || event.ctrlKey) && event.key === "k") {
      event.preventDefault()
      this._open()
    }
  }
}
